export class PessoaModel {

  id?: number;
  pessoaId?: number;
  indicadorCliente?: boolean;
  indicadorFornecedor?: boolean;
  indicadorTerceirizado?: boolean;
  indicadorConcorrente?: boolean;
  indicadorFuncionario?: boolean;
  tipo?: string;
  nome?: string;
  apelido?: string;
  email?: string;
  telefone?: string;
  ramal?: string;
  fax?: string;
  ativo?: boolean;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  usuarioCadastro?: string;
  dataCadastro?: any;
  cpf?: string;
  sexo?: string;
  cnpj?: string;
  razaoSocial?: string;
  nomeFantasia?: string;
  site?: string;
  inscricaoEstadual?: string;
  inscricaoMunicipal?: string;
  ramoAtuacao?: string;
  situacaoId?: string;
  porteId?: string;
  dataAcesso?: any;
  dataDiario?: any;

  constructor(options: PessoaModel = {}) {

    this.id = options.id || null;
    this.pessoaId = options.pessoaId || null;
    this.indicadorCliente = options.indicadorCliente || null;
    this.indicadorFornecedor = options.indicadorFornecedor || null;
    this.indicadorTerceirizado = options.indicadorTerceirizado || null;
    this.indicadorConcorrente = options.indicadorConcorrente || null;
    this.indicadorFuncionario = options.indicadorFuncionario || null;
    this.tipo = options.tipo || null;
    this.nome = options.nome || null;
    this.apelido = options.apelido || null;
    this.email = options.email || null;
    this.telefone = options.telefone || null;
    this.ramal = options.ramal || null;
    this.fax = options.fax || null;
    this.ativo = options.ativo || null;
    this.usuarioAlteracao = options.usuarioAlteracao || null;
    this.dataAlteracao = options.dataAlteracao || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataCadastro = options.dataCadastro || null;
    this.cpf = options.cpf || null;
    this.sexo = options.sexo || null;
    this.cnpj = options.cnpj || null;
    this.razaoSocial = options.razaoSocial || null;
    this.nomeFantasia = options.nomeFantasia || null;
    this.site = options.site || null;
    this.inscricaoEstadual = options.inscricaoEstadual || null;
    this.inscricaoMunicipal = options.inscricaoMunicipal || null;
    this.ramoAtuacao = options.ramoAtuacao || null;
    this.situacaoId = options.situacaoId || null;
    this.porteId = options.porteId || null;
    this.dataAcesso = options.dataAcesso || null;
    this.dataDiario = options.dataDiario || null;

  }
}
